import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { countryConfig } from 'src/country-config/country-config';
import { TokenParams, urlToken } from 'src/app/data/networking/models/support/support';
import { map } from 'rxjs/operators';

export interface responseToken {
  code: string,
  message: string,
  data: { token: string }
} 

@Injectable({providedIn: 'root'})
export class ChatService {
    
  constructor(private http: HttpClient) {}

  private httpOptions(): {headers: HttpHeaders} {
    const params: { [key: string]: string } = {
      Country: countryConfig.indicator,
      'Content-Type': 'application/json'
    };
    return {headers: new HttpHeaders(params)};
  }

  getUserToken(params: TokenParams) {
    return this.http.post(urlToken, params, this.httpOptions())
      .pipe(map((response: responseToken ) => response.data))
      .toPromise();
  }
  
}